module.exports = __webpack_public_path__ + "static/img/masterclassSucceed.e9bc0ca4.png";